// extracted by mini-css-extract-plugin
export var footer = "_ro-0";
export var inherit = "_ro-1";
export var input = "_ro-2";
export var modalContent = "_ro-3";
export var quillEditor = "_ro-4";
export var subtitle = "_ro-5";